import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/UserConext";

/**
 * ProtectedRoute component that checks if user is authenticated
 * If user is logged in (user.user is not null), renders the child routes
 * If user is not logged in, redirects to /login
 */
const ProtectedRoute = () => {
  const { user } = useUser();

  // Check if user is logged in (user.user exists and is not null)
  const isAuthenticated = user?.user !== null && user?.user !== undefined;

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
